<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading
                :active.sync="isLoading"
                :is-full-page="fullPage"
            ></loading>
        </div>

        <breadcrumb :page="$t('form.setting.createPartner')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert
                    v-model="alert"
                    :variant="alertClass"
                    dismissible
                    fade
                    >{{ alertMessage }}</b-alert
                >

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">
                                {{ $t("form.setting.createPartner") }}
                            </div>
                            <b-button
                                type="submit"
                                variant="primary"
                                class="float-right"
                                >{{ $t("button.save") }}</b-button
                            >
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label
                                    >{{ $t("form.setting.partnerCode")
                                    }}<span class="text-danger">*</span></label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="partner.PartnerCode"
                                     :class="{ 'is-invalid': $v.partner.PartnerCode.$error }"
                                />
                                <div
                                    class="invalid-feedback"
                                    v-if="!$v.partner.PartnerCode.required"
                                > {{$t('form.validation.required')}}</div>
                            </div>

                            <div class="form-group">
                                <label
                                    >{{ $t("form.setting.partnerName")
                                    }}<span class="text-danger">*</span></label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="partner.PartnerName"
                                    :class="{ 'is-invalid': $v.partner.PartnerName.$error }"
                                />
                                <div
                                    class="invalid-feedback"
                                    v-if="!$v.partner.PartnerName.required"
                                > {{$t('form.validation.required')}}</div>
                            </div>

                            <div class="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="partner.PartnerActive"
                                    />
                                    {{ $t("form.setting.active") }}
                                </label>
                            </div>

                            <div class="form-group">
                                <label>{{
                                    $t("form.setting.sortOrder")
                                }}</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="partner.PartnerSortOrder"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
    props: ["permissions"],

    data() {
        return {
            alert: false,
            alertClass: "",
            alertMessage: "",

            isLoading: false,
            fullPage: true,

            partner: {
                PartnerCode: "",
                PartnerName: "",
                PartnerActive: null,
                PartnerSortOrder: null
            }
        };
    },
    validations: {
        partner: {
                PartnerCode:{required},
                PartnerName:{required}
            }
    },
    mounted() {
        if (!this.permissions.createSettingsPartners) {
            return this.$router.push("/");
        }
    },

    methods: {
        submit() {
           this.$v.$touch();

            if (this.$v.$invalid) {
                let errorMsg = "";
                if (this.$v.partner.PartnerCode.$error) {
                    errorMsg = "Partner Code";
                }

                if (this.$v.partner.PartnerName.$error) {
                    errorMsg = errorMsg? errorMsg+ " and Partner Name": "Partner Name";
                }

                this.showAlert(
                    this.$t("form.validation.mandatoryFieldsError", {
                        errors: errorMsg
                    }),
                    "danger"
                );
                return;
            }

            this.clearAlert();

            this.isLoading = true;

            axios
                .post("/api/partners", this.partner)
                .then(response => {
                    this.isLoading = false;

                    if (response.data.success) {
                        this.showAlert(response.data.message);

                        setTimeout(() => {
                            this.$router.push({
                                name: "PartnerIndex"
                            });
                        }, 2000);
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.showAlert(error.response.data.message, "danger");
                });
        },

        showAlert(message, cls = "success") {
            this.alertMessage = message;
            this.alertClass = cls;
            this.alert = true;
        },

        clearAlert() {
            this.alert = false;
            this.alertClass = "";
            this.alertMessage = "";
        }
    }
};
</script>
